import { render } from "./HomeBackground.vue?vue&type=template&id=6245ec8f&scoped=true"
import script from "./HomeBackground.vue?vue&type=script&lang=ts"
export * from "./HomeBackground.vue?vue&type=script&lang=ts"

import "./HomeBackground.vue?vue&type=style&index=0&id=6245ec8f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6245ec8f"

export default script